
export const ticketData = [
    {
        id: 1,
        title: 'Order',
        num: '2563',
        num2: '5263',
        num3: '5288',
        class: 'primary'
    },
    {
        id: 2,
        title: 'Pending',
        num: '8943',
        num2: '2356',
        num3: '9693',
        class: 'secondary'
    },
    {
        id: 3,
        title: 'Running',
        num: '2500',
        num2: '1230',
        num3: '5288',
        class: 'warning'
    },
    {
        id: 4,
        title: 'Smooth',
        num: '2060',
        num2: '8500',
        num3: '7568',
        class: 'info'
    },
    {
        id: 5,
        title: 'Done',
        num: '5600',
        num2: '3852',
        num3: '4455',
        class: 'success'
    },
    {
        id: 6,
        title: 'Cancel',
        num: '2560',
        num2: '9371',
        num3: '0033',
        class: 'danger'
    },

];

export const supportData = [

    {
        image: ` <div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/1.jpg' alt='Generic placeholder image' />
            <div class="align-self-center">
                <div>Tiger Nixon</div>
            </div>
        </div>`,
        position: 'System Architect',
        salary: '$320,800',
        office: 'Edinburgh',
        skill: 'primary',
        extn: 5421,
        email: 't.nixon@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/2.png' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>John Iron</div>
            </div>
        </div>`,
        position: 'Junior Technical Author',
        salary: '$86,000',
        office: 'San Francisco',
        skill: 'secondary',
        extn: 1562,
        email: 'a.cox@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/3.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Hetl grome</div> 
            </div>
        </div>`,
        position: 'Software Engineer',
        salary: '$132,000',
        office: 'London',
        skill: 'success',
        extn: 2558,
        email: 'b.greer@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/6.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Jiyu Watlt</div>
            </div>
        </div>`,
        position: 'Integration Specialist',
        salary: '$372,000',
        office: 'New York',
        skill: 'success',
        extn: 4804,
        email: 'b.williamson@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/5.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Sham Mandela</div>
            </div>
        </div>`,
        position: 'Pre-Sales Support',
        salary: '$106,450',
        office: 'New York',
        skill: 'danger',
        extn: 8330,
        email: 'c.vance@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/1.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Yeam Zole</div>
            </div>
        </div>`,
        position: 'Junior Technical Author',
        salary: '$86,000',
        office: 'San Francisco',
        skill: 'info',
        extn: 1562,
        email: 'a.cox@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/10.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Reooy Keim</div>
            </div>
        </div>`,
        position: 'Senior Javascript Developer',
        salary: '$433,060',
        office: 'San Francisco',
        skill: 'warning',
        extn: 6224,
        email: 'c.kelly@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/7.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Walt Cream</div>
            </div>
        </div>`,
        position: 'Senior Javascript Developer',
        salary: '$433,060',
        office: 'San Francisco',
        skill: 'danger',
        extn: 6224,
        email: 'c.kelly@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/1.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Green Dets</div>
            </div>
        </div>`,
        position: 'Accountant',
        salary: '$162,700',
        office: 'Tokyo',
        skill: 'primary',
        extn: 5407,
        email: 'a.satou@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/5.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Root Nixon</div>
            </div>
        </div>`,
        position: 'Integration Specialist',
        salary: '$372,000',
        office: 'New York',
        skill: 'info',
        extn: 4804,
        email: 'b.williamson@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/8.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Trrem Jimm</div>
            </div>
        </div>`,
        position: 'Sales Assistant',
        salary: '$137,500',
        office: 'San Francisco',
        skill: 'warning',
        extn: 9608,
        email: 'h.chandler@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/10.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Boohn Yrrmy</div>
            </div>
        </div>`,
        position: 'Integration Specialist',
        salary: '$327,900',
        office: 'Tokyo',
        skill: 'secondary',
        extn: 6200,
        email: 'r.davidson@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/9.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Ytem iremm</div>
            </div>
        </div>`,
        position: 'Javascript Developer',
        salary: '$205,500',
        office: 'San Francisco',
        skill: 'success',
        extn: 2360,
        email: 'c.hurst@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/8.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Zaid Miner</div>
            </div>
        </div>`,
        position: 'Software Engineer',
        salary: '$103,600',
        office: 'Edinburgh',
        skill: 'info',
        extn: 1667,
        email: 's.frost@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/2.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Zeem Xerro</div>
            </div>
        </div>`,
        position: 'Office Manager',
        salary: '$90,560',
        office: 'London',
        skill: 'warning',
        extn: 3814,
        email: 'j.gaines@datatables.net'
    },

    {
        image: `<div class="d-flex"><img class='rounded-circle img-30 me-3' src='/assets/images/user/5.jpg' alt='Generic placeholder image' />
            <div body className="align-self-center">
                <div>Jigaer Tim</div>
            </div>
        </div>`,
        position: 'Support Lead',
        salary: '$342,000',
        office: 'Edinburgh',
        skill: 'danger',
        extn: 9497,
        email: 'q.flynn@datatables.net'
    },
];